<div [formGroup]="formGroup()" data-testid="assigned-to-container">
  <p-select
    optionLabel="name"
    dataKey="id"
    tooltip="{{ controlName().value?.name }}"
    tooltipStyleClass="text-xs"
    tooltipPosition="bottom"
    [filter]="true"
    filterBy="name"
    [autofocusFilter]="true"
    [virtualScroll]="true"
    [virtualScrollItemSize]="virtualScrollItemSize"
    scrollHeight="280px"
    appendTo="body"
    [loading]="loading()"
    [options]="staffOptions()"
    [formControl]="controlName()"
    [resetFilterOnHide]="true"
    [showClear]="showClear()"
    placeholder="{{ placeHolder() }}"
    styleClass="{{ styleClass() }}"
    (onChange)="onSelectStaff(SelectedStaff)"
    aria-label="staff-dropdown"
    data-testid="staff-dropdown"
  >
    <ng-template pTemplate="selectedItem">
      @if (controlName().value) {
        <div
          class="flex align-items-center justify-content-between"
          data-testid="selected-staff-container"
        >
          <span class="w-2rem absolute left-0 ml-1">
            @if (controlName().value.ff_picture) {
              <p-avatar
                [image]="controlName().value.ff_picture"
                class="h-full"
                aria-label="staff-avatar"
                data-testid="staff-avatar"
              />
            } @else {
              <p-avatar
                styleClass="text-sm w-2rem h-2rem mr-2"
                label="{{
                  controlName().value.name ||
                    controlName().value.name_primary_language
                    | titlecase
                    | shortName
                }}"
                aria-label="staff-avatar-initials"
                data-testid="staff-avatar-initials"
              />
            }
          </span>
          <strong
            class="text-900 ml-5 pl-1 md:w-7rem overflow-hidden text-overflow-ellipsis"
            data-testid="selected-staff-name"
            >{{ controlName().value.name }}</strong
          >
        </div>
      }
    </ng-template>

    <!-- Lightweight row template: virtual scroll only mounts visible rows -->
    <ng-template let-staff pTemplate="item">
      <div
        class="flex align-items-center gap-2 w-full px-1"
        [style.height.px]="virtualScrollItemSize"
        data-testid="staff-list-item"
      >
        @if (staff.ff_picture) {
          <p-avatar
            [image]="staff.ff_picture"
            styleClass="w-1rem h-1rem flex-shrink-0"
            aria-label="staff-list-avatar"
            data-testid="staff-list-avatar"
          />
        } @else {
          <p-avatar
            styleClass="text-xs w-1rem h-1rem flex-shrink-0"
            label="{{ staff.name | titlecase | shortName }}"
            aria-label="staff-list-avatar-initials"
            data-testid="staff-list-avatar-initials"
          />
        }
        <span
          class="text-sm overflow-hidden text-overflow-ellipsis white-space-nowrap"
          data-testid="staff-list-name"
          >{{ staff.name }}</span
        >
      </div>
    </ng-template>
  </p-select>
</div>
